import { Column, Row } from '@amzn/meridian';
import type { DestinationUrlInput } from 'features/campaign/campaign.types';
import type { FC } from 'react';
import { LinkTypeSelect } from './LinkTypeSelect';
import { LinkValueInput } from './LinkValueInput';

type LinkUrlSectionProps = {
  linkType: DestinationUrlInput;
  linkValue: string;
  validationError?: string;
  showVariations?: boolean;
  onLinkTypeChange: (newType: DestinationUrlInput) => void;
  onLinkValueChange: (newValue: string) => void;
  onShowVariationsChange?: (checked: boolean) => void;
};

/**
 * LinkUrlSection - Shared UI component for URL input section
 * Used by both LinkBuilder and LinkUrlBuilder
 * Contains: LinkTypeSelect + LinkValueInput in a responsive row layout
 */
export const LinkUrlSection: FC<LinkUrlSectionProps> = ({
  linkType,
  linkValue,
  onLinkTypeChange,
  onLinkValueChange,
  onShowVariationsChange,
  showVariations,
  validationError,
}) => (
  <Row alignmentVertical="top" spacing="400">
    <Column width="30%">
      <LinkTypeSelect onChange={onLinkTypeChange} value={linkType} />
    </Column>

    <Column width="70%">
      <LinkValueInput
        linkType={linkType}
        onChange={onLinkValueChange}
        onDealsVariationsChange={onShowVariationsChange}
        showDealsVariations={showVariations}
        validationError={validationError}
        value={linkValue}
      />
    </Column>
  </Row>
);
